module.exports = __webpack_public_path__ + "static/media/iStock-489037784.0d97bd5a.jpg";